import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"id":"edit_payroll_header","fluid":""}},[(_vm.loading)?_c(VSkeletonLoader,{attrs:{"type":"list-item-avatar-two-line","width":"100%"}}):_vm._e(),(_vm.errormsg != '')?_c(VAlert,{attrs:{"type":"error"}},[_vm._v("\n\t\t"+_vm._s(_vm.errormsg)+"\n\t")]):_vm._e(),(_vm.payroll_header.id != 0)?_c('v-payroll-header-entry',{attrs:{"payroll_header":_vm.payroll_header,"popup_editors":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }